import * as api from '../../services/item/apiMatrixChildren';
import * as apiPriceBook from '../../services/pricebook/apiPricebook';
import groupBy from 'lodash/groupBy';

import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import { browserHistory } from 'react-router';
import { call, put, select, takeEvery } from 'redux-saga/effects';

export function* generateMatrixItemsSaga(feathersApp) {
  yield takeEvery('GENERATE_MATRIX_ITEMS', callGenerateMatrixItems, feathersApp);
}

export function* fetchMatrixDetailForEditSaga(feathersApp) {
  yield takeEvery('FETCH_MATRIX_DETAIL_FOR_EDIT', callFetchMatrixDetailForEdit, feathersApp);
}

function* callFetchMatrixDetailForEdit(feathersApp, action) {
  console.log('start calling item for edit on matrix');
  const { tenant, user } = yield select();
  const { id } = action;
  try {
    if (id) {
      yield put({ type: 'FETCH_DATA_BY_ID_INPROGRESS', payload: { docType: DocType.ITEM, id } });

      const fetchParams = { tenant, user, id };
      const results = yield call(api.fetchDefaultItemLocation, feathersApp, fetchParams);
      console.log({ defaultItemLocation: results });
      const allPriceBookRefList = yield call(apiPriceBook.fetchPriceBooksByReference, feathersApp, fetchParams);

      if (!results.docs[0]) {
        // yield put({ type: 'CLEAR_MATRIX_GENERATION_DATA' });
        yield put({ type: 'FETCH_DATA_BY_ID_ERROR', message: 'No Default Item Location' });
        // browserHistory.push(`/admin/item/edit/${id}`);
        return;
      }
      let doc = yield call(api.fetchMatrixDetailForEdit, feathersApp, fetchParams);
      const matrix_children = yield call(api.fetchMatrixChildren, feathersApp, fetchParams);
      if (matrix_children.docs.length > 0) {
        let matrixItemIds = [];
        matrix_children.docs.forEach((mItem) => {
          matrixItemIds.push(mItem.id);
        })
        const matrixFetchParams = { tenant, user, matrixItemIds};
        const matrixDefaultItemLoc = yield call(api.fetchMatrixDefaultItemLoc, feathersApp, matrixFetchParams);
        let assignedPriceBookRefList = [];
        for (let i=0; i < matrixDefaultItemLoc.docs.length; i++ ) {
          const mItemLoc = matrixDefaultItemLoc.docs[i];
          assignedPriceBookRefList.push(mItemLoc.price_book_reference);
        }

        const filter = {
          "price_book_reference": {
            "$in": assignedPriceBookRefList
          }
        }
        const fields = ["_id", "name", "price_book_reference"];
        
        const priceBookFetchParams = { tenant, user, filter, fields};
        const priceBookRefList = yield call(apiPriceBook.fetchPriceBooksByReference, feathersApp, priceBookFetchParams);
        const newPriceBookRefList = groupBy(priceBookRefList, "price_book_reference");
        let newMatrixChildren = [];
        matrix_children.docs.forEach((mItem) => {
          let newMatrixChild = {...mItem};
          for (let i=0; i < matrixDefaultItemLoc.docs.length; i++ ) {
            const mItemLoc = matrixDefaultItemLoc.docs[i];
            if (mItem.id === mItemLoc.item._id) {
              newMatrixChild.price_book_reference = {
                "_id" : mItemLoc.price_book_reference,
                "name" : mItemLoc.price_book_reference,
                "priceBookName":newPriceBookRefList[mItemLoc.price_book_reference][0].name

              }
              break;
            }
          }
          newMatrixChildren.push(newMatrixChild);
        })

        doc.matrix_children = newMatrixChildren;
      } else {
        doc.matrix_children = [];
      }      
      doc.price_book_list = allPriceBookRefList;
      const defaultItemLocation = yield call(api.fetchDefaultItemLocation, feathersApp, fetchParams);
      if (defaultItemLocation.docs) {
        doc.item_location = defaultItemLocation.docs.map((itemLoc) =>{
            let newItemLoc = {...itemLoc};
            const priceBookRef = itemLoc.price_book_reference;
            if (priceBookRef) {
              newItemLoc.price_book_reference = {
                _id: priceBookRef,
                id: priceBookRef,
                name: priceBookRef

              };
            }
            return newItemLoc;
        });
      }
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error });
  }
}

function* callGenerateMatrixItems(feathersApp, action) {
  // yield put({ type: 'MATRIX_GENERATE_ITEMS_INPROGRESS' });
  yield put({ type: 'SAVE_RECORD_INPROGRESS' });
  console.log("calling generate Matrix item function");
  try {
    const { matrixData } = action;
    const {
      itemId,
      matrixDefinitionId,
      matrixChildrenList = [],
      locationList,
      excluded_locations_ids
    } = matrixData;

    // const parentItemId = itemId;
    //const matrixAttributeResult = yield call(api.getMatrixAttribute, feathersApp, { id: matrixDefinitionId });
    //const parentItemResult = yield call(api.fetchMatrixDetailForEdit, feathersApp, { id: parentItemId } );
    //const parentDefaultItemLocResult = yield call( api.fetchDefaultItemLocation, feathersApp, { id: parentItemId } );
    // let defaultItemLoc = parentDefaultItemLocResult.docs[0];
    // delete defaultItemLoc._rev;
    // delete defaultItemLoc.id;
    // delete defaultItemLoc.on_hand;

    let location_ids = []
    locationList.forEach((location) => {
      location_ids.push(location.id);
    })

    const generateParams = {
      parent_item_id : itemId,
      matrix_attribute_id: matrixDefinitionId,
      matrixChildrenList,
      location_ids: location_ids,
      excluded_locations_ids,
    }

    const matrixDetailList = yield call(
      api.generateMatrixItem,
      feathersApp,
      generateParams
    );

    console.log("matrixDetailList ====>", matrixDetailList);
    let numberOfItems = matrixDetailList.processed.total;

    yield callFetchMatrixDetailForEdit(feathersApp, { id: itemId, silent: true });
    browserHistory.push(`/admin/matrix_detail/edit/${itemId}`);
    yield common.doneSaveRecord(matrixDetailList, numberOfItems + ' Matrix Children were processed');
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}
